import ajax from '@/utils/ajax';
import requestUrls from '@/assets/js/requestUrls';

// 查询优惠券详情
export const reqCouponInfo = (requestBody) => (ajax(requestUrls.reqCouponInfoUrl, requestBody, 'POST'));
export const reqReceiveCoupon = (requestBody) => (ajax(requestUrls.reqReceiveCouponUrl, requestBody, 'POST'));
export const reqCheckCoupon = (requestBody) => (ajax(requestUrls.reqCheckCouponUrl, requestBody, 'POST'));
export const reqReceivebatchCoupon = (requestBody) => (ajax(requestUrls.reqReceivebatchCouponUrl, requestBody, 'POST'));

// 批量查询有效的优惠券信息
export const reqValidCoupon = (couponId) => (ajax(`/web/v1/coupon/batch/select-all/valid?couponId=${couponId}`));


// 差社群信息
export const reqCommunity = (id) => (ajax(`/web/v1/community/${id}`));
